import React, { useEffect, useState } from "react";
import ViewTable from "../../../../Components/Common/ViewTable";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Alert,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { get, post, put, del, api } from "../../../../utils/api";
import Cards from "../../../../Components/Common/Cards";
import {
  formatTransportMetricCard,
  formatTransportRouteCard,
} from "../cardDisplayUtils";
import FilterListIcon from "@mui/icons-material/FilterList";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import FilterModal from "../../../../Components/Common/FilterModal";
import Form from "./Form";
import View from "./View";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import ShipTransportationBulkUploadReview from "./ShipTransportationBulkUploadReview";
import BulkUploadSkippedDialog from "../../../../Components/Common/BulkUploadSkippedDialog";
import uploadicon from "../../../../assets/images/uploadicon.svg";
import { useUser } from "../../../../context/AuthContext";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";
import {
  shouldShowFacilityColumn,
  withFacilityViewTableHeader,
  mapTableDataWithFacility,
} from "../../../../utils/facilityColumn";

const ShipTransport = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);

  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});

  const [filterOrigin, setFilterOrigin] = useState([]);
  const [filterDestination, setFilterDestination] = useState([]);
  const [filterCategoryOfShipment, setfilterCategoryOfShipment] = useState([]);
  const [filterTypeOfShipment, setfilterTypeOfShipment] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(1);
  const [Deletedata, setdataDelete] = useState(null);
  const [filters, setFilters] = useState({});

  const [cardData, setCardData] = useState({
    mostCommonRoute: [],
    totalLoad: 0,
    totalDistanceTraveled: 0,
  });

  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [deleteDialog, setDeleteDialog] = useState(false);

  const [excelData, setExcelData] = useState(null);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [bulkUploadTable, setBulkUploadTable] = useState(false);
  const [matchData, setMatchData] = useState([]);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState([]);
  const [skippedUploadDialog, setSkippedUploadDialog] = useState({
    open: false,
    skippedEntries: [],
    inserted: 0,
    skipped: 0,
  });

  const uploadErrorClose = () => {
    setBulkUploadModal(false);
    setBulkUploadTable(true);
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    setBulkUploadTable(false);
    setMatchData([]);
    setFormDataBulkUpload([]);
    setSkippedUploadDialog({
      open: false,
      skippedEntries: [],
      inserted: 0,
      skipped: 0,
    });
    fetchData();
  };

  const fetchExcelData = async () => {
    // Define shipment categories and their corresponding types
    const shipmentOptions = {
      "Liquid Shipment": [
        "Crude tanker",
        "Products tanker",
        "Chemical tanker",
        "LNG tanker",
        "LPG tanker",
      ],
      "Dry Shipment": [
        "Bulk carrier",
        "General cargo",
        "Container ship",
        "Vehicle transport",
        "RoRo-Ferry",
        "Large RoPax Ferry",
        "Refrigerated cargo",
      ],
    };

    let arr = [];
    let serialNo = 1;

    // Loop through each shipment category
    Object.keys(shipmentOptions).forEach((category) => {
      // Loop through each shipment type in the category
      shipmentOptions[category].forEach((type) => {
        arr.push({
          "S No.": serialNo++,
          "Month (in 01/25 or Jan-25)": "",
          "Shipment Category": category,
          "Shipment Type": type,
          "Transportation Type(Upstream/Downstream)": "",
          "Distance Cover": "",
          Origin: "",
          Destination: "",
          "Freight Load (in Tonnes)": "",
          Remark: "",
          Document: "",
          // Include available types for UI dropdowns
        });
      });
    });

    setExcelData(arr);
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const headers = withFacilityViewTableHeader([
    { key: "createdAt", label: "Date", sortable: true, width: "12%" },
    {
      key: "consumptionPeriod",
      label: "Consumption Month",
      sortable: true,
      width: "15%",
    },
    // { key: "facilityName", label: "Facility", sortable: true },
    { key: "origin", label: "Source", sortable: true, width: "14%" },
    {
      key: "destination",
      label: "Destination",
      sortable: true,
      width: "14%",
    },
    {
      key: "categoryOfShipment",
      label: "Shipment Category",
      sortable: true,
      width: "13%",
    },
    {
      key: "typeOfShipment",
      label: "Shipment Type",
      sortable: true,
      width: "12%",
    },
    {
      key: "distanceCovered",
      label: "Distance Travelled (Km)",
      sortable: true,
      width: "12%",
    },
  ], showFacilityColumn);

  // let bannerData = [
  //   {
  //     title: "Most Common Water Route",
  //     description: cardData?.mostCommonRoute ?? [],
  //   },

  //   {
  //     title: "Total Freight Load",
  //     description: `${cardData?.totalLoad ?? 0} MT`,
  //   },

  //   {
  //     title: "Total Distance Travelled",
  //     description: `${cardData?.totalDistanceTraveled ?? 0} Km`,
  //     filter: "option",
  //     key: "categoryOfShipment",
  //     filterValues: ["Liquid Shipment", "Dry Shipment"],
  //     defaultValue:
  //       filters?.categoryOfShipment === undefined
  //         ? "Liquid Shipment"
  //         : filters?.categoryOfShipment,
  //   },
  // ];

  let bannerData = [
    {
      title: "Most Common Water Route",
      description: formatTransportRouteCard(cardData?.mostCommonRoute),
    },
    {
      title: "Total Freight Load",
      description: formatTransportMetricCard(cardData?.totalLoad),
      unit: "MT",
    },
    {
      title: "Total Distance Travelled",
      description: formatTransportMetricCard(cardData?.totalDistanceTraveled),
      unit: "Km",
      filter: "option",
      key: "categoryOfShipment",
      filterValues: ["Liquid Shipment", "Dry Shipment"],
      defaultValue:
        filters?.categoryOfShipment === undefined
          ? "Liquid Shipment"
          : filters?.categoryOfShipment,
    },
  ];

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      key: "consumptionPeriod",
      type: "month",
      title: "Consumption Month",
      value: [],
    },
    {
      title: "Source",
      type: "option",
      key: "origin",
      value: filterOrigin,
    },
    {
      title: "Shipment Category",
      type: "option",
      key: "categoryOfShipment",
      value: filterCategoryOfShipment,
    },
    {
      title: "Shipment Type",
      type: "option",
      key: "typeOfShipment",
      value: filterTypeOfShipment,
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: filterDestination,
    },
    {
      title: "Freight Load (Tonnes)",
      type: "limit",
      key: "load",
      value: ["one", "two"],
    },
  ];

  const fetchData = async () => {
    let filter = { ...filterObj };
    if (filter.load) {
      filter.minLoad = parseFloat(filterObj.load.min);
      filter.maxLoad = parseFloat(filterObj.load.max);
    }
    if (filter.createdAt?.start) {
      filter.startDate = filter.createdAt.start;
    }
    if (filter.createdAt?.end) {
      filter.endDate = filter.createdAt.end;
    }
    if (filter.consumptionPeriod?.start) {
      filter.startMonth = filter.consumptionPeriod.start;
    }
    if (filter.consumptionPeriod?.end) {
      filter.endMonth = filter.consumptionPeriod.end;
    }
    if (Array.isArray(filter.origin)) {
      filter.origin = filter.origin.join("|");
    }
    if (Array.isArray(filter.destination)) {
      filter.destination = filter.destination.join("|");
    }
    const queryParams = new URLSearchParams({
      ...filter,
      page: currentPage,
      limit: 10,
      sortField: sortConfig.key,
      sortOrder: sortConfig.direction,
    }).toString();
    await get(`/scope3/shipTransportation/get?${queryParams}`)
      .then((res) => {
        let arr = res?.data?.data?.map((item) => {
          return {
            createdAt: new Date(item.createdAt).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            }),
            consumptionMonth:
              new Date(
                item.consumptionPeriod.year, // Pass the year
                item.consumptionPeriod.month - 1
              ).toLocaleDateString("en-GB", {
                month: "short",
                // year: "numeric",
              }) +
              " " +
              item.consumptionPeriod.year,
            facilityName: item?.facility?.facilityName,
            origin: item?.origin,
            // destination: item?.destination,
            categoryOfShipment: item?.categoryOfShipment,
            typeOfShipment: item?.typeOfShipment,
            freightLoad: item?.freightLoad,
            remark: item?.remark,
            editRemarkReason: item?.editRemarkReason || "",
            action: "View",
            id: item?._id,
            // data: item,
            ...item,
          };
        });
        setTableData(arr);
        setPageSize(res.data.totalPages);
        setTotalPages(res.data.totalPages);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, sortConfig, filterObj]);

  const fetchFilters = async () => {
    await get(`/scope3/shipTransportation/ship/filter`)
      .then((res) => {
        setFilterOrigin(res?.data?.data?.origin);
        setFilterDestination(res?.data?.data?.destination);
        setfilterTypeOfShipment(res?.data?.data?.typeOfShipment);
        setfilterCategoryOfShipment(res?.data?.data?.categoryOfShipment);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  const handleDelete = (index) => {
    setDeleteDialog(true);
    setdataDelete(index?.id);
  };

  const fetchCardData = async () => {
    try {
      const res = await get(`/scope3/shipTransportation/cardData`, {
        params: {
          shipmentCategory: filters?.categoryOfShipment,
        },
      });
      setCardData({
        mostCommonRoute: [
          res?.data?.data?.mostCommonRoute?.origin,
          res?.data?.data?.mostCommonRoute?.destination,
        ],
        totalLoad: res?.data?.data?.totalFreightLoad,
        totalDistanceTraveled: res?.data?.data?.totalDistanceTraveled,
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, [filters]);

  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setIsModalOpen(true);
    } else if (type === "edit") {
      setEditModal(true);
      setEditData(dataForEdit);
    }
  };

  const openViewModal = (data) => {
    setEditData(data);
    setViewModal(true);
  };

  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setCurrentPage(1);
  };

  const isFilterApplied = Object.keys(filterObj).some(
    (key) =>
      filterObj[key] &&
      (Array.isArray(filterObj[key])
        ? filterObj[key].length > 0
        : filterObj[key])
  );

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
    } else if (type === "edit") {
      setEditModal(false);
      setEditData({});
    }
  };

  const handleSubmit = async (data, edit) => {
    let method = edit ? put : post;
    const url = edit
      ? `/scope3/shipTransportation/update?Id=${data?._id}`
      : `/scope3/shipTransportation/add`;

    try {
      const res = await method(url, data);
      setsnackOpen({
        open: true,
        message: res.data.message,
        severity: "success",
      });
      setIsModalOpen(false);
      fetchData();
      fetchCardData();
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        const errorMessages = err.response.data.errors
          .map((error) => error.msg)
          .join(", ");
        setsnackOpen({
          open: true,
          message: errorMessages,
          severity: "error",
        });
      }
      setIsModalOpen(false);
    }
  };

  const handleFilterChangeCards = (cardTitle, filterValue, type) => {
    if (type === "date") {
      const [year, month] = filterValue.split("-");
      setFilters((prev) => ({
        ...prev,
        month,
        year,
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        [cardTitle]: filterValue,
      }));
    }
  };

  return (
    <>
      <Cards
        data={bannerData}
        title="Ship Transportation"
        onFilterChange={handleFilterChangeCards}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "2rem",
          marginBottom: "1.5rem",
          gap: "1rem",
          width: "100%",
        }}
      >
        <div style={{ display: "flex", gap: "1rem" }}>
          {!user?.companyAdmin ? (
            <>
              <Button
                variant="contained"
                endIcon={<AddIcon />}
                sx={{
                  backgroundColor: "#1c486b",
                  fontSize: "16px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontWeight: "500",
                  "&:hover": {
                    backgroundColor: "#1c486b",
                    opacity: 0.9,
                  },
                }}
                onClick={() => openModal("add")}
              >
                Add New
              </Button>
              <Button
                variant="contained"
                endIcon={<img src={uploadicon} alt="upload" />}
                sx={{
                  backgroundColor: "#fff",
                  fontSize: "16px",
                  textTransform: "none",
                  color: "rgba(28, 72, 107, 1)",
                  fontFamily: "Inter",
                  fontWeight: "500",
                  "&:hover": {
                    backgroundColor: "#fff",
                    opacity: 0.9,
                  },
                }}
                onClick={() => setBulkUploadModal(true)}
              >
                Upload
              </Button>
            </>
          ) : null}
        </div>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#ffffff",
            textTransform: "none",
            fontSize: "16px",
            fontFamily: "Inter",
            fontWeight: "500",
            color: "black",
            "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
            "&:hover .dot-icon": { color: "#FFFFFF" },
          }}
          onClick={() => setIsFilterModalOpen(true)}
        >
          Filter <FilterListIcon sx={{ marginLeft: "0.5rem" }} />
          {isFilterApplied && (
            <FiberManualRecordIcon
              className="dot-icon"
              sx={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#488257",
                marginLeft: "5px",
                fontFamily: "Inter",
                textTransform: "none",
              }}
            />
          )}
        </Button>
      </div>

      {/* {deleteDialog && (
        <Dialog open={deleteDialog}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you really want to delete this entry?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialog(false)} color="primary">
              Cancel
            </Button>
            <Button onClick={handleDeleteAggree} color="secondary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )} */}
      {deleteDialog && (
        <DeleteAlertDialog
          {...{
            deleteDialog,
            setDeleteDialog,
            method: "delete",
            id: Deletedata,
            url: `${api}/scope3/shipTransportation/delete`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}
      <ViewTable
        title={"Ship Transportation"}
        headers={headers}
        data={mapTableDataWithFacility(tableData, showFacilityColumn)}
        onSort={handleSort}
        sortConfig={sortConfig}
        totalPages={totalPages}
        page={currentPage}
        editIcon={user?.companyAdmin ? "disable" : "enable"}
        count={pageSize}
        onPageChange={(page) => setCurrentPage(page)}
        onView={(row) => {
          openViewModal(row);
        }}
        onEdit={(row) => openModal("edit", row)}
        onDelete={handleDelete}
      />
      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>
      <Form
        isOpen={isModalOpen || editModal}
        onClose={() => closeModal(editModal ? "edit" : "add")}
        onSubmit={handleSubmit}
        header={
          editModal ? "Edit Ship Transportation" : "Add Ship Transportation"
        }
        initialData={editData}
        isEditing={editModal}
      />

      <View
        isOpen={viewModal}
        onClose={() => {
          setViewModal(false);
          setEditData({});
        }}
        header={"View Data"}
        initialData={editData}
        handleEdit={(row) => {
          openModal("edit", row);
          setViewModal(false);
        }}
        companyAdmin={user?.companyAdmin}
      />

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />

      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          setsnackOpen={setsnackOpen}
          isBulkUploadModal={bulkUploadModal}
          excelData={excelData}
          fileName={"ship transportation"}
          url={"/scope3/shipTransportation/bulkupload"}
          setMatchData={setMatchData}
          setFormDataBulkUpload={setFormDataBulkUpload}
          matchedKey="shipTransportationStatusList"
          errorClose={uploadErrorClose}
          setBulkUploadModal={setBulkUploadModal}
        />
      )}

      {bulkUploadTable && (
        <ShipTransportationBulkUploadReview
          bulkUploadTable={bulkUploadTable}
          matchData={matchData}
          formDataBulkUpload={formDataBulkUpload}
          setFormDataBulkUpload={setFormDataBulkUpload}
          setsnackOpen={setsnackOpen}
          bulkUploadUrl="/scope3/shipTransportation/jsonupload"
          onClose={() => {
            setBulkUploadTable(false);
            setMatchData([]);
            setFormDataBulkUpload([]);
            fetchData();
          }}
          onConfirm={(data) => {
            setBulkUploadTable(false);
            setMatchData([]);
            setFormDataBulkUpload([]);
            fetchData();
            fetchCardData();

            const skippedEntries = data?.skippedEntries;
            const hasSkipped =
              Array.isArray(skippedEntries) && skippedEntries.length > 0;
            const inserted = Number(data?.inserted ?? 0);
            const skipped = Number(data?.skipped ?? 0);

            if (hasSkipped) {
              setSkippedUploadDialog({
                open: true,
                skippedEntries,
                inserted,
                skipped,
              });
            }
          }}
        />
      )}

      <BulkUploadSkippedDialog
        open={skippedUploadDialog.open}
        skippedEntries={skippedUploadDialog.skippedEntries}
        inserted={skippedUploadDialog.inserted}
        skipped={skippedUploadDialog.skipped}
        downloadFileName="ship_transportation_skipped"
        onClose={() =>
          setSkippedUploadDialog({
            open: false,
            skippedEntries: [],
            inserted: 0,
            skipped: 0,
          })
        }
        // onDownload={(rows) => setExcelData(rows)}
      />
    </>
  );
};

export default ShipTransport;
